import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryEmbedClassicRoute: InvariantJiraRoute = {
	name: 'software-summary-classic-embed',
	path: '/jira/software/c/projects/:projectKey/summary/embed',
};
